"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _constant = require("./constant");
var _Image = _interopRequireDefault(require("./Image.proptypes"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var transitionEffect = (0, _styledComponents.css)(["transition:", ";&:hover{transform:", ";}"], function (props) {
  return props.hoverAnimation ? "all 1s ease-out" : null;
}, function (props) {
  return props.hoverAnimation ? "scale(1.1)" : null;
});
var LowResAnimation = (0, _styledComponents.css)(["filter:blur(8px);"]);
var Img = _styledComponents.default.img.withConfig({
  displayName: "Image__Img",
  componentId: "sc-x2qeul-0"
})(["width:", ";height:", ";object-fit:", ";", ";", ";", ";"], function (props) {
  return props.width ? props.width : 'initial';
}, function (props) {
  return props.height ? props.height : 'initial';
}, function (props) {
  return props.centerFocus ? 'cover' : 'unset !important';
}, function (_ref) {
  var islowResolutionImageAvailable = _ref.islowResolutionImageAvailable;
  return islowResolutionImageAvailable && (0, _styledComponents.css)(["position:absolute;"]);
}, function (_ref2) {
  var lowResImage = _ref2.lowResImage,
    islowResolutionImageAvailable = _ref2.islowResolutionImageAvailable;
  return islowResolutionImageAvailable && lowResImage && LowResAnimation;
}, transitionEffect);
var ImgContainer = _styledComponents.default.div.withConfig({
  displayName: "Image__ImgContainer",
  componentId: "sc-x2qeul-1"
})(["background:", ";overflow:hidden;position:relative;", ";width:", ";height:", ";border-radius:", ";border:", ";"], function (props) {
  return props.placeHolderBackground ? props.theme.backgroundColor[props.placeHolderBackground] : props.theme.backgroundColor.tertiary;
}, function (_ref3) {
  var placeHolderIcon = _ref3.placeHolderIcon;
  return placeHolderIcon && (0, _styledComponents.css)(["text-align:center;"]);
}, function (props) {
  return props.width ? props.width : 'initial';
}, function (props) {
  return props.height ? props.height : 'initial';
}, function (props) {
  return props.radius ? props.radius : '0px';
}, function (props) {
  return props.borderColor ? "1px solid ".concat(props.theme.colors[props.borderColor]) : null;
});
var StyledIcon = _styledComponents.default.div.withConfig({
  displayName: "Image__StyledIcon",
  componentId: "sc-x2qeul-2"
})(["position:relative;top:calc(50% - 10px);"]);
var getImageTypeIcon = function getImageTypeIcon(type) {
  return type in _constant.IMAGE_TYPE_ICONS ? _constant.IMAGE_TYPE_ICONS[type] : '';
};
var getIcon = function getIcon(icon) {
  return /*#__PURE__*/_react.default.createElement(StyledIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    color: "greyLighter",
    fontsize: "titleNormal",
    accessible: false
  }));
};
var ImageComponent = function ImageComponent(props) {
  var src = props.src,
    alt = props.alt,
    height = props.height,
    width = props.width,
    onLoad = props.onLoad,
    radius = props.radius,
    theme = props.theme,
    type = props.type,
    borderColor = props.borderColor,
    hoverAnimation = props.hoverAnimation,
    centerFocus = props.centerFocus,
    customProperties = props.customProperties,
    accessible = props.accessible,
    lowResolutionImageUrl = props.lowResolutionImageUrl,
    enableProgressiveImageLoading = props.enableProgressiveImageLoading,
    placeHolderBackground = props.placeHolderBackground,
    lazyLoadImage = props.lazyLoadImage;
  var ref = _react.default.useRef();
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var placeHolderIcon = getImageTypeIcon(type);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(!lazyLoadImage),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isVisible = _useState4[0],
    setIsVisible = _useState4[1];
  var islowResolutionImageAvailable = enableProgressiveImageLoading && !!lowResolutionImageUrl;
  var loadImageSeparately = function loadImageSeparately(imageUrl) {
    var imageToLoad = new Image();
    imageToLoad.src = imageUrl;
    imageToLoad.onload = function () {
      setLoading(false);
    };
  };
  var loadLowResImage = function loadLowResImage() {
    var imageToLoad = new Image();
    imageToLoad.src = lowResolutionImageUrl;
  };
  (0, _react.useEffect)(function () {
    if (lowResolutionImageUrl) {
      loadLowResImage();
    }
  }, []);
  (0, _react.useEffect)(function () {
    var observer;
    if ((lazyLoadImage || islowResolutionImageAvailable) && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (_ref4) {
        var _ref5 = (0, _slicedToArray2.default)(_ref4, 1),
          entry = _ref5[0];
        if (entry.intersectionRatio > 0) {
          setIsVisible(true);
          loadImageSeparately(src);
          observer.unobserve(entry.target);
          observer.disconnect();
        }
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      });
      if (ref.current) {
        observer.observe(ref.current);
      }
    }
    return function () {
      return observer && observer.disconnect && observer.disconnect();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   * Previously named as returnImageWithCenterFocusProgressiveImageLoading()
   * The previous method returned div for center focus.
   * Center focus is now included within img tag and div is not used
   */

  var returnProgressiveImage = function returnProgressiveImage() {
    return /*#__PURE__*/_react.default.createElement("span", null, isVisible && /*#__PURE__*/_react.default.createElement(Img, {
      src: src,
      alt: alt,
      width: width,
      style: {
        opacity: !loading ? 1 : 0
      },
      lowResImage: false,
      height: height,
      onLoad: onLoad,
      hoverAnimation: hoverAnimation,
      radius: radius,
      centerFocus: centerFocus,
      islowResolutionImageAvailable: islowResolutionImageAvailable
    }), /*#__PURE__*/_react.default.createElement(Img, {
      src: lowResolutionImageUrl,
      alt: alt,
      width: width,
      lowResImage: true,
      style: {
        visibility: !loading ? 'hidden' : 'visible'
      },
      height: height,
      onLoad: onLoad,
      hoverAnimation: hoverAnimation,
      radius: radius,
      centerFocus: centerFocus,
      islowResolutionImageAvailable: islowResolutionImageAvailable
    }));
  };
  /**
   * Replaces the previous methods returnImagewithCenterFocus() and returnDefaultImageWithoutCenterFocus()
   * which returned div and img respectively
   */

  var returnDefaultImage = function returnDefaultImage() {
    return /*#__PURE__*/_react.default.createElement(Img, {
      src: src,
      alt: alt,
      height: height,
      width: width,
      onLoad: onLoad,
      hoverAnimation: hoverAnimation,
      radius: radius,
      islowResolutionImageAvailable: islowResolutionImageAvailable,
      centerFocus: centerFocus
    });
  };
  var ImageHandler = function ImageHandler() {
    if (islowResolutionImageAvailable) {
      return returnProgressiveImage();
    }
    if (lazyLoadImage) {
      if (isVisible) {
        return returnDefaultImage();
      }
      return null;
    }
    return returnDefaultImage();
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ImgContainer, (0, _extends2.default)({
      height: height,
      width: width,
      onLoad: onLoad,
      radius: radius,
      placeHolderIcon: placeHolderIcon,
      borderColor: borderColor
    }, customProperties, {
      tabIndex: tabIndex,
      theme: themeContext,
      islowResolutionImageAvailable: islowResolutionImageAvailable,
      placeHolderBackground: placeHolderBackground,
      ref: ref
    }), placeHolderIcon && !src ? getIcon(placeHolderIcon) : null, src && ImageHandler() || null);
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
ImageComponent.propTypes = _Image.default.PropTypes;
ImageComponent.defaultProps = _Image.default.DefaultProps;
var _default = ImageComponent;
exports.default = _default;